import {Component} from '@angular/core';
import {AbstractDynamicFormFieldDirective} from './abstract-dynamic-form-field.directive';

@Component({
  selector: 'app-dff-textarea',
  templateUrl: './dff-textarea.component.html',
  styleUrls: ['./dff-textarea.component.scss']
})
export class DffTextareaComponent extends AbstractDynamicFormFieldDirective {

  readonly quillConfig = getQuillConfig();
  value = '';

  validate(value: string): string[] {
    return [];
  }

  writeValue(value: string) {
    this.value = value;
  }

}

function getQuillConfig() {
  return {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline'],
        [{header: [1, 2, 3, 4, 5, 6, false]}],
        [{align: []}, {list: 'ordered'}, {list: 'bullet'}],
        [{indent: '-1'}, {indent: '+1'}],
        ['link']
      ],
    },
  };
}
